export default __webpack_public_path__ + "media/zurb/img/case-study-libdib/libdib-img3-78d11b352a63d7a9342c066e632ce26f.jpg";